'use strict';

require("core-js/modules/es6.regexp.replace");

require("core-js/modules/es6.regexp.match");

var maskPhoneNumber = function maskPhoneNumber(phone) {
  try {
    if (window.event.keyCode === 8) return false;
  } catch (e) {
    console.error(e);
  }

  var x = phone.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
  phone = !x[2] ? x[1] : '(' + x[1] + ') ' + x[2] + (x[3] ? '-' + x[3] : '');
  return phone;
};

module.exports = maskPhoneNumber;